module.exports = __webpack_public_path__ + "static/media/baseMeme4thumb.21a22580.jpg";